<template>
  <div>
    <XVactionbar>
      <template slot="actionbuttons" v-if="Number($route.params.sa) === 0">
        <div class="btn-group">
          <button
            type="button"
            id="butOK"
            class="btn btn-primary btn-xs"
            @click.prevent="btnOK"
            v-if="($route.params.personid === 'null' || this.SPE697pagesettings.codeautorised === 2 ) && isAfter(new Date(this.SPE697pagesettings.maxEndDate), new Date(Date.now()))" 
          >
            <font-awesome-icon :icon="['far', 'check']" />
            {{ translation(6516) }}
          </button>
          <button type="button" id="butCancel" class="btn btn-primary btn-xs" @click.prevent="btnCancel">
            <font-awesome-icon icon="times" />
            {{ translation(6515) }}
          </button>
          <button
            type="button"
            id="butVerwijder"
            class="btn btn-danger btn-xs"
            @click.prevent="openConfirm()"
            v-if="($route.params.personid === 'null' || this.SPE697pagesettings.codeautorised === 2 ) && SPE697pagesettings.codeAllowDelete === 1"
          >
            <font-awesome-icon :icon="['fa', 'trash']" />
            {{ translation(6517) }}
          </button>
        </div>
        <div class="btn-group">
<!-- Changed by:	Huub Maas
-- Change date:	14-9-2023
-- Description:	Issue 29878
--butextend altijd leeg en @butextendDate altijd vullen als die nog binnen max zit.
-->
          <button
            :disabled="disable.disabledBtnExtend"
            type="button"
            id="butExtend"
            class="btn btn-default btn-xs"
            @click.prevent="btnExtend"
            v-if="SPE697pagesettings.butextend !== null && ($route.params.personid === 'null' || this.SPE697pagesettings.codeautorised === 2 )"
          >
            <font-awesome-icon :icon="['fa', 'expand']" />
            {{ translation(10814) }}
          </button>
          <button
            type="button"
            id="butOverzichtpersoon"
            class="btn btn-default btn-xs"
            @click.prevent="btnOverzichtpersoon"
            v-if="
              SPE697pagesettings.butOverzichtpersoon !== null &&
              SPE697pagesettings.status !== 'gesloten' &&
              ($route.params.personid === 'null' || this.SPE697pagesettings.codeautorised === 2 )
            "
          >
            <font-awesome-icon :icon="['fa', 'users']" />
            {{ translation(6590) }}
          </button>
          <button
            type="button"
            id="butfillform"
            class="btn btn-default btn-xs"
            @click.prevent="btnfillform"
            v-if="
              SPE697pagesettings.butfillform !== null &&
              SPE697pagesettings.status === 'open' &&
              $route.params.personid === 'null'
            "
          >
            <font-awesome-icon :icon="['far', 'edit']" />
            {{ translation(10126) }}
          </button>
        </div>
      </template>
    </XVactionbar>
    <div v-if="dataloaded === true">
      <div class="row margin20" v-if="translation(9157) !== ''">
        <div class="col-md-12">
          <span id="lblTitel" class="titel">{{ translation(9157) }}</span>
        </div>
      </div>
      <div class="row margin20bottom" v-if="graphdata.length > 0">
        <div class="col-md-12">
          <XVgraphcontrol :graphdata="graphdata" @graphClick="graphClick"></XVgraphcontrol>
        </div>
      </div>
      <div class="row margin20">
        <div class="col-md-12">
          <span id="lblinfo" v-html="translation(lblinfo)"></span>
        </div>
      </div>
      <div class="spe697form">
        <fieldset>
          <div id="trCreateName" class="row margin20" v-if="this.SPE697pagesettings.createName !== null">
            <div class="col-md-4">
              <label>{{ translation(16147) }}</label>
            </div>
            <div class="col-md-8">
              <label>{{ this.SPE697pagesettings.createName }}</label>
            </div>
          </div>
          <div id="trStartDate" class="row margin20">
            <div class="col-md-4">
              <span class="pull-right">
                <XVhelpcontrol :helptext="translation(6552)"></XVhelpcontrol>
              </span>
              <label>{{ translation(6520) }}</label>
              <span>
                <font-awesome-icon :icon="['fal', 'asterisk']" size="xs" />
              </span>
            </div>
            <div class="col-md-8 form-group has-feedback" v-bind:class="startdateClass">
              <XVdate
                :disabled="disable.disabledStartDate"
                key="tbxTotDiv"
                id="tbxStartDate"
                name="tbxStartDate"
                v-model.trim="inputfields.iStartDate"
                :data-vv-as="translation(6520)"
                v-validate="{ XVDateDefault: true, required: true } && startdateClass"
              ></XVdate>
              <span
                class="form-group__message"
                v-if="!isAfter(new Date(Date.now() - 1 * 24 * 3600 * 1000), inputfields.iStartDate)"
                >{{ errors.first('tbxStartDate') }}</span
              >
              <span
                class="form-group__message"
                v-if="isAfter(new Date(Date.now() - 1 * 24 * 3600 * 1000), inputfields.iStartDate)"
                >{{ translation(6640) }}</span
              >
            </div>
          </div>
          <div id="trEndDate" class="row">
            <div class="col-md-4">
              <span class="pull-right">
                <XVhelpcontrol :helptext="translation(6553)"></XVhelpcontrol>
              </span>
              <label>{{ translation(6521) }}</label>
              <span>
                <font-awesome-icon :icon="['fal', 'asterisk']" size="xs" />
              </span>
            </div>

            <div class="col-md-8 form-group has-feedback" v-bind:class="endDateClass">
              <XVdate
                id="tbxEndDate"
                name="tbxEndDate"
                v-model.trim="inputfields.iEndDate"
                :data-vv-as="translation(6521)"
                v-validate="{ XVDateDefault: true, required: true }"
              ></XVdate>
              <span
                class="form-group__message a"
                v-if="!isAfter(inputfields.iStartDate, inputfields.iEndDate) && errors.first('tbxEndDate')"
                >{{ errors.first('tbxEndDate') }}</span
              >
              <span class="form-group__message b" v-if="isAfter(inputfields.iStartDate, inputfields.iEndDate)">{{
                translation(6642)
              }}</span>
              <span
                class="form-group__message c"
                v-if="
                  isAfter(inputfields.iEndDate, new Date(this.SPE697pagesettings.maxEndDate)) &&
                  this.SPE697pagesettings.maxEndDate !== null
                "
                >{{ translation(10815) + ' ' + enddatestring }}</span
              >
            </div>
          </div>
          <XVbootstraprow
            id="trTitle"
            :label="translation(10686)"
            :required="true"
            :helptext="translation(10687)"
            v-if="showMutliLangTitle === true"
          >
            <XVmultilanguagetextbox
              :rows="1"
              :disabled="disable.disabledMultiLangTitle"
              v-model="inputfields.multiLangTitletextID"
            ></XVmultilanguagetextbox>
          </XVbootstraprow>
          <div class="row headerrow trDescriptionHeader" v-if="showMultiLangDesc === true">
            <div class="col-md-12">
              <XVhelpcontrol :helptext="translation(10688)" class="hcheaderrow"></XVhelpcontrol>
              <label>{{ translation(10689) }}</label>
            </div>
          </div>
          <div class="row trDescription" v-if="showMultiLangDesc === true">
            <div class="col-md-12">
              <XVmultilanguagetextbox
                :rows="8"
                :disabled="disable.disabledMultiLangDesc"
                v-model="inputfields.multiLangDescriptiontextID"
              ></XVmultilanguagetextbox>
            </div>
          </div>
        </fieldset>
      </div>
      <fieldset class="margin20">
        <legend>{{ translation(6547) }}</legend>
        <div
          class="row lblevalclosed"
          v-if="this.$route.params.personid !== 'null' || SPE697pagesettings.status === 'gesloten'"
        >
          <div class="col-md-12 form-group">
            <span>{{ translation(lblevalclosed) }}</span>
          </div>
        </div>
        <XVtableV2
          :filterfunc="filterfunc"
          :tablesetting="msfDetailTable.tablesetting"
          :tablecolumnsetting="msfDetailTable.tablecolumnsetting"
          :tabledata="msfDetailTable.tabledata"
          :rowvisible="msfDetailTable.rowvisible"
          v-on:sortXVTable="XVTablesort"
          :paging="true"
          :XVtableSetRowStateProperty="compXVtableSetRowStateProperty"
        >
          <template slot="tonen" slot-scope="dr">
            <span v-if="dr.row.tonen">
              <a :href="dr.row.tonen">
                <i class="fa fa-search"></i>
                {{ translation(786) }}
              </a>
            </span>
          </template>
          <template slot="tonen_detailrow" slot-scope="dr">
            <div class="row">
              <div class="col-md-offset-4 col-md-8 col-sm-offset-4 col-sm-8 col-xs-12 form-group">
                <span v-if="dr.row.tonen">
                  <a :href="dr.row.tonen">
                    <i class="fa fa-search"></i>
                    {{ translation(786) }}
                  </a>
                </span>
              </div>
            </div>
          </template>
          <template slot="export" slot-scope="dr">
            <span v-if="dr.row.export">
              <a :href="dr.row.export" target="_blank">
                <font-awesome-icon :icon="['fal', 'file-excel']" />
                {{ translation(15336) }}
              </a>
            </span>
          </template>
          <template slot="export_detailrow" slot-scope="dr">
            <div class="row">
              <div class="col-md-offset-4 col-md-8 col-sm-offset-4 col-sm-8 col-xs-12 form-group">
                <span v-if="dr.row.export">
                  <a :href="dr.row.export" target="_blank">
                    <font-awesome-icon :icon="['fal', 'file-excel']" />
                    {{ translation(15336) }}
                  </a>
                </span>
              </div>
            </div>
          </template>
        </XVtableV2>
      </fieldset>
    </div>
    <modal v-model="showConfirm" title="Modal 1" ref="modal" id="modal-demo" :header="false">
      <p v-html="translation(9597)"></p>
      <div slot="footer" class="modalconfirmbuttons">
        <button
          id="btnDeleteModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="deleteConfirm()"
        >
          {{ translation(23) }}
        </button>
        <button
          id="btnCloseModal"
          type="button"
          class="btn btn-primary modalconfirmbutton"
          @click.prevent="closeConfirm"
        >
          {{ translation(17) }}
        </button>
      </div>
    </modal>
  </div>
</template>


<script>
'use strict'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { FAMixin, util } from 'pevueglobal'
import { sync } from 'vuex-pathify'
import { isAfter, isEqual } from 'date-fns'
// ????? URL naar beheer https://pe.xaurum.nl/peapp/allroles/SPE697PatientEnqueteDetail/6133/0/null
// ????? URL naar prof https://pe.xaurum.nl/peapp/allroles/SPE697PatientEnqueteDetail/6133/0/null
// msfid, stand alone en personid (bij beheerder gevuld)
// aanpassing 696: if sa naar deze pagina = 1, dan openen in nieuw tab

export default {
  mixins: [FAMixin],
  data: function () {
    return {
      showConfirm: false,
    }
  },
  async mounted() {
    this.spe697getTexten()
    if (this.$route.params.sa) {
      this.setStandalone(Number(this.$route.params.sa))
    }
    let setPersonID = this.$route.params.personid !== 'null' ? Number(this.$route.params.personid) : ''
    let setMSFID = Number(this.$route.params.MsfID)
    // Set cookie to get back to this page after fill in his own form or show filled form of someone else.
    util.UsetCookie('strAppUrlReferrer', window.location.pathname)
    let msfpersonID = {
      MSFid: setMSFID,
      MSFtblpersonid: setPersonID,
    }
    let graphdataInput = {
      pagename: 'SPE697_PR_PatientEnquete_detailV2.aspx',
      clientid: '',
      filters: [
        {
          key: 'personID',
          value: setPersonID,
        },
        {
          key: 'msfID',
          value: setMSFID,
        },
        {
          key: 'tblMultiSourceFeedbackID',
          value: setMSFID,
        },
      ],
    }
    await this.getSpe697PageSettings(msfpersonID)
    await this.getSpe697GetGraphs(graphdataInput)
    if (this.SPE697pagesettings.redirect !== null) {
      window.open(this.SPE697pagesettings.redirect)
    }
    this.stopLoading()
  },
  computed: {
    inputfields: sync('SPE696PatientEnquete/inputfields'),
    ...mapGetters('SPE696PatientEnquete', [
      'SPE697pagesettings',
      'dataloaded',
      'showMutliLangTitle',
      'showMultiLangDesc',
      'disable',
      'graphdata',
      'msfDetailTable',
      'standalone',
    ]),
    lblinfo() {
      return this.$route.params.personid !== 'null' || this.SPE697pagesettings.createName !== null ? '10580' : '9158'
    },
    lblevalclosed() {
      return this.$route.params.personid === 'null' ? '10439' : '10539'
    },
    startdateClass() {
      if (this.SPE697pagesettings.status === 'notstarted') {
        return {
          'form-group--error':
            this.errors.has('tbxStartDate') ||
            isAfter(new Date(Date.now() - 1 * 24 * 3600 * 1000), this.inputfields.iStartDate),
        }
      } else {
        return ''
      }
    },
    endDateClass() {
      if (
        this.SPE697pagesettings.maxEndDate !== null &&
        this.inputfields.iEndDate > new Date(this.SPE697pagesettings.maxEndDate)
      ) {
        return {
          'form-group--error':
            this.errors.has('tbxEndDate') ||
            isAfter(this.inputfields.iStartDate, this.inputfields.iEndDate) ||
            this.inputfields.iEndDate > new Date(this.SPE697pagesettings.maxEndDate),
        }
      } else {
        return {
          'form-group--error':
            this.errors.has('tbxEndDate') || isAfter(this.inputfields.iStartDate, this.inputfields.iEndDate),
        }
      }
    },
    enddatestring() {
      return util.jsDateToStringDate(new Date(this.SPE697pagesettings.maxEndDate))
    },
  },
  methods: {
    isAfter,
    isEqual,
    ...mapActions('SPE696PatientEnquete', [
      'getSpe697PageSettings',
      'getSpe697GetGraphs',
      'getGraphUrl',
      'spe697getTexten',
      'updateMSF',
      'deleteMSF',
    ]),
    ...mapMutations('SPE696PatientEnquete', [
      'toggleExtend',
      'XVTablesort',
      'XVtablecolumnsettingchanged',
      'XVtableSetRowStateProperty',
      'XVTablesort',
      'compInitXVtableState',
      'compXVtableSetRowStateProperty',
      'setStandalone',
    ]),
    ...mapMutations(['addNotification']),
    filterfunc(tabledata) {
      return tabledata
    },
    btnCancel() {
      if (this.$route.params.personid !== 'null') {
        this.$router.push({ name: 'SPE696PatientEnquete', params: { personid: this.$route.params.personid } })
      } else {
        this.$router.push({ name: 'SPE696PatientEnquete' })
      }
    },
    btnOK() {
      // customdateval aangemaakt ivm isAfter errors die niet worden toegevoegd aan de vee-validate errors.
      // ofwel de isAfter ging bijv wel af, maar je kon alsnog opslaan.
      let customdateval = true
      if (this.SPE697pagesettings.status === 'notstarted') {
        customdateval = isAfter(this.inputfields.iStartDate, new Date(Date.now() - 1 * 24 * 3600 * 1000))
      }
      customdateval = !isAfter(this.inputfields.iStartDate, this.inputfields.iEndDate) && customdateval === true
      if (this.SPE697pagesettings.maxEndDate !== null && customdateval === true) {
        if (
          isAfter(new Date(this.SPE697pagesettings.maxEndDate), this.inputfields.iEndDate) ||
          isEqual(new Date(this.SPE697pagesettings.maxEndDate), this.inputfields.iEndDate)
        ) {
          customdateval = true
        } else {
          customdateval = false
        }
      }
      if (customdateval === true) {
        this.$validator.validate().then((result) => {
          if (result) {
            let updateProps = {
              tblMultiSourceFeedbackID: Number(this.$route.params.MsfID),
              tblMultiSourceFeedbackDateStart: util.DateForDatabase(this.inputfields.iStartDate),
              tblMultiSourceFeedbackDateEnd: util.DateForDatabase(this.inputfields.iEndDate),
              MSFtblpersonid: Number(this.$route.params.personid),
            }
            this.updateMSF(updateProps)
          } else {
            this.addNotification({
              groupname: 'warning',
              message: this.translation(14642),
            })
          }
        })
      } else {
        this.addNotification({
          groupname: 'warning',
          message: this.translation(14642),
        })
      }
    },
    btnOverzichtpersoon() {
      window.location = this.SPE697pagesettings.butOverzichtpersoon
      // old source window.open(this.SPE697pagesettings.butOverzichtpersoon)
    },
    btnfillform() {
      window.location = this.SPE697pagesettings.butfillform
      // old source window.open(this.SPE697pagesettings.butfillform)
    },
    btnExtend() {
      this.addNotification({
        groupname: 'warning',
        message: this.translation(10816) + this.enddatestring,
      })
      this.toggleExtend()
    },
    graphClick: function (graphClickinfo) {
      const setPersonID =
        this.$route.params.personid !== 'null'
          ? Number(this.$route.params.personid)
          : Number(this.SPE697pagesettings.tblPersonID)
      const graphGetUrlinputApi = {
        pagename: 'SPE697_PR_PatientEnquete_detailV2.aspx',
        clientid: '',
        filters: [
          {
            key: 'personID',
            value: setPersonID,
          },
          {
            key: 'msfID',
            value: Number(this.$route.params.MsfID),
          },
          {
            key: 'tblMultiSourceFeedbackID',
            value: Number(this.$route.params.MsfID),
          },
        ],
        graphIDForUrl: graphClickinfo.graphID,
        defaultfilter: '',
      }
      this.getGraphUrl({ graphGetUrlinputApi: graphGetUrlinputApi, graphShowInPopup: graphClickinfo.graphShowInPopup })
    },
    openConfirm: function (tablerow) {
      this.showConfirm = true
    },
    closeConfirm: function () {
      this.showConfirm = false
    },
    deleteConfirm: function () {
      this.deleteMSF(Number(this.$route.params.MsfID))
      this.showConfirm = false
    },
  },
}
</script>
<style scoped>
.headerrow {
  background: #eeeeee;
  font-weight: 600;
  margin-bottom: 20px;
  margin-left: -20px;
  margin-right: -20px;
  padding: 5px;
}
</style>
<style>
.spe697form .graphQuestion {
  margin-bottom: 0px;
}
</style>
